import React, { useMemo, useRef } from 'react';
import { getBezierPath } from 'react-flow-renderer';
import { DeleteIcon } from '../../icons';

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  onEdgeClick,
  onEdgeHover,
}) => {
  const pathRef = useRef(null)
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  function getCubicBezierMidpoint(path) {
    // Extract numbers (x0 y0 x1 y1 x2 y2 x3 y3)
    const nums = path.match(/-?\d+(\.\d+)?/g).map(Number);
    if (nums.length !== 8) {
      throw new Error("Expected cubic path: M x0 y0 C x1 y1, x2 y2, x3 y3");
    }
  
    const [x0, y0, x1, y1, x2, y2, x3, y3] = nums;
  
    // Cubic Bézier interpolation
    const cubic = (t, p0, p1, p2, p3) =>
      (1 - t) ** 3 * p0 +
      3 * (1 - t) ** 2 * t * p1 +
      3 * (1 - t) * t ** 2 * p2 +
      t ** 3 * p3;
  
    const t = 0.5; // parametric midpoint
    return {
      x: cubic(t, x0, x1, x2, x3),
      y: cubic(t, y0, y1, y2, y3),
    };
  }

  const {x: midX, y: midY} = useMemo(() => getCubicBezierMidpoint(edgePath), [edgePath])

  return (
    <g>
      {/* Invisible hit area */}  
      <path
        d={edgePath}
        fill="none"
        className="react-flow__edge-interaction"
        strokeOpacity={0}
        pointerEvents="visibleStroke"
        strokeWidth={20} // bigger hover/click area
        style={{ cursor: 'pointer' }}
      />  

      {/* Visible edge */}
      <path
        id={id}
        ref={pathRef}
        style={{
          ...style,
          cursor: 'pointer',
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        pointerEvents='none'
      />
      
      <foreignObject
          x={midX - 15}
          y={midY - 15}
          width={34}
          height={34}
          style={{ overflow: 'visible', display: 'none', cursor: 'pointer' }}
        >
          <div 
            style={{
              borderRadius: '50%', 
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center', 
              background: '#f3f3f4',
              width: 30,
              height: 30,
              outline: '5px solid rgb(223, 226, 228)',
              pointerEvents: 'none',
              zIndex: '9999',
              position: 'relative'
            }}
            id="delete_connection_btn"
            onClick={onEdgeClick}
          >
            <DeleteIcon 
              style={{
                color: '#505050',
                stroke: 'transparent',
                pointerEvents: 'none'
              }}
            />
          </div>
        </foreignObject>
      
    </g>
  );
};

export default CustomEdge;
